// Bulk school upload template: the downloadable .xlsx that tells admins exactly which
// columns the bulk-add upload expects. The static workbook lives in
// public/templates/ and is generated from this same column list, so the two stay in step.
//
// The header labels below are the human-readable form of the aliases the backend parser
// (SchoolBulkParser) matches on — matching is case/space/punctuation-insensitive, so e.g.
// "School Name" -> "schoolname", "URN/GIAS ID" -> "urngiasid", "FSM %" -> "fsm". Keep this
// list and the static template aligned with those aliases.

// Column headers, in the order they appear on the template's first sheet.
export const BULK_SCHOOL_TEMPLATE_COLUMNS = [
  'School Name',
  'URN/GIAS ID',
  'Number of Pupils',
  'Address',
  'Country',
  'School Type',
  'Boarding',
  'Post 16',
  'Nursery',
  'Religious Character',
  'Diocese',
  'FSM %',
  'Federated',
  'Postcode',
];

// Path of the static template within the public/ folder.
export const BULK_SCHOOL_TEMPLATE_FILE = 'templates/bulk-add-schools-template.xlsx';

// Suggested filename when the browser saves the download.
export const BULK_SCHOOL_TEMPLATE_DOWNLOAD_NAME = 'bulk-add-schools-template.xlsx';

// Resolve the template URL against the app's public base path so it works under any
// deploy sub-path (create-react-app serves public/ assets relative to PUBLIC_URL).
export const getBulkSchoolTemplateUrl = () => {
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return `${base}/${BULK_SCHOOL_TEMPLATE_FILE}`;
};
